export default "__VITE_ASSET__BUkoEzKK__"